import { Box, Flex, Grid, Paper, RangeSlider, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { NumberInput } from '@components';
import { renderActiveMethodButton } from '../CustomerViewEvaluationMethods';
import classes from '../CustomerViewEvaluationMethods.module.css';
import { CustomerViewEvaluationMethodsFormValues } from '../useCustomerViewEvaluationMethodsFormInitializer';

interface CustomerViewEvaluationMethodAIHsCodeProps {
  form: UseFormReturnType<CustomerViewEvaluationMethodsFormValues>;
}

export const CustomerViewEvaluationMethodAIHsCode: React.FC<CustomerViewEvaluationMethodAIHsCodeProps> = ({ form }) => {
  const { evaluationMethods } = form.values;

  const handleChange = (field: 'from' | 'to', value: number) => {
    form.setFieldValue(`evaluationMethods.evalMethodAIHSCode.range.${field}`, value);
  };

  return (
    <Paper className={`${classes.evaluationMethodContainer} ${evaluationMethods.evalMethodAIHSCode?.activateMethod || false ? classes.activeMethod : ''}`}>
      <Flex>
        <Box className={classes.evaluationMethodContainerHeaderBody}>
          <Text fz={14} mb={10}>
            EvalMethod AI HS code
          </Text>
        </Box>
        {renderActiveMethodButton(form, evaluationMethods.evalMethodAIHSCode?.activateMethod || false, 'evaluationMethods.evalMethodAIHSCode.activateMethod')}
      </Flex>

      <Text className={classes.evaluationMethodText}>Range of acceptance</Text>

      <Box pl={7} pr={7}>
        <RangeSlider
          min={0.0}
          max={1.0}
          minRange={0.01}
          step={0.01}
          pt={10}
          pb={15}
          value={[evaluationMethods.evalMethodAIHSCode?.range?.from || 0, evaluationMethods.evalMethodAIHSCode?.range?.to || 1]}
          onChange={(values) => {
            handleChange('from', Number(values[0]));
            handleChange('to', Number(values[1]));
          }}
          marks={[
            { value: 0.0, label: '0.0' },
            { value: 1.0, label: '1.0' },
          ]}
        />
      </Box>

      <Grid mt="xl">
        <Grid.Col span={6}>
          <NumberInput
            {...form.getInputProps('evaluationMethods.evalMethodAIHSCode.range.from')}
            label="From"
            step={0.01}
            onChange={(value) => {
              form.setFieldValue('evaluationMethods.evalMethodAIHSCode.range.from', Number(value));
            }}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <NumberInput
            {...form.getInputProps('evaluationMethods.evalMethodAIHSCode.range.to')}
            label="To"
            step={0.01}
            onChange={(value) => {
              form.setFieldValue('evaluationMethods.evalMethodAIHSCode.range.to', Number(value));
            }}
          />
        </Grid.Col>
      </Grid>
    </Paper>
  );
};
